(() => {
  const selector = '[id*="__hero_bFkDDJ"] .hero h1 > span';
  const ns = 'http://www.w3.org/2000/svg';
  const mountWord = word => {
    const text = [...word.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent).join('').trim();
    if (!text || !word.offsetWidth || !word.offsetHeight) return;
    word.querySelectorAll('.steep-hero-twinkle,.steep-sparkle-layer').forEach(n => n.remove());
    const style = getComputedStyle(word);
    const width = word.offsetWidth, height = word.offsetHeight;
    const canvas = document.createElement('canvas');
    canvas.width = width; canvas.height = height;
    const ctx = canvas.getContext('2d', {willReadFrequently: true});
    if (!ctx) return;
    ctx.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    ctx.letterSpacing = style.letterSpacing === 'normal' ? '0px' : style.letterSpacing;
    const metrics = ctx.measureText(text);
    const ascent = metrics.fontBoundingBoxAscent || metrics.actualBoundingBoxAscent;
    const descent = metrics.fontBoundingBoxDescent || metrics.actualBoundingBoxDescent;
    ctx.fillStyle = '#fff';
    ctx.fillText(text, parseFloat(style.paddingLeft) || 0, (height-ascent-descent)/2+ascent);
    const pixels = ctx.getImageData(0,0,width,height).data;
    const candidates = [];
    for (let y=3; y<height-3; y+=3) {
      for (let x=3; x<width-3; x+=3) {
        if (pixels[(y*width+x)*4+3]>220) candidates.push([x,y]);
      }
    }
    if (!candidates.length) return;
    const layer = document.createElement('span');
    layer.className = 'steep-sparkle-layer';
    layer.setAttribute('aria-hidden','true');
    const mask = `url("${canvas.toDataURL()}")`;
    layer.style.maskImage = mask; layer.style.webkitMaskImage = mask;
    for (let i=0; i<32; i++) {
      const [x,y] = candidates[(i*997+127)%candidates.length];
      const svg = document.createElementNS(ns,'svg');
      svg.setAttribute('viewBox','0 0 24 24');
      svg.setAttribute('aria-hidden','true'); svg.setAttribute('focusable','false');
      svg.classList.add('steep-hero-twinkle');
      if (i>=18) svg.classList.add('steep-hero-twinkle--extra');
      const size = word.matches('.pdp-category__sparkling') ? Math.max(3,Math.min(8,height*.18))+(i%3) : Math.max(9,Math.min(22,height*.13))+(i%3)*2;
      svg.style.cssText = `--spark-x:${x/width*100}%;--spark-y:${y/height*100}%;--spark-size:${size}px;--spark-duration:${2.6+(i%5)*.35}s;--spark-delay:${-i*.31}s`;
      const path = document.createElementNS(ns,'path');
      path.setAttribute('d','M12 0C13.5 8 16 10.5 24 12C16 13.5 13.5 16 12 24C10.5 16 8 13.5 0 12C8 10.5 10.5 8 12 0Z');
      svg.appendChild(path); layer.appendChild(svg);
    }
    word.appendChild(layer);
  };
  const mountLeaf = image => {
    if (!image.complete || !image.naturalWidth || !image.offsetWidth) return;
    const parent = image.parentElement;
    parent.querySelector('.steep-leaf-sparkles')?.remove();
    const layer = document.createElement('span');
    layer.className = 'steep-leaf-sparkles'; layer.setAttribute('aria-hidden','true');
    const mask = `url("${image.currentSrc || image.src}")`;
    Object.assign(layer.style, {left:image.offsetLeft+'px',top:image.offsetTop+'px',width:image.offsetWidth+'px',height:image.offsetHeight+'px',transform:getComputedStyle(image).transform,maskImage:mask,webkitMaskImage:mask});
    const points = [[30,25],[47,25],[65,33],[29,44],[50,43],[68,50],[30,64],[48,62],[65,70],[40,78],[56,81],[72,63],[40,34],[57,52],[36,54],[60,41],[44,70],[53,33]];
    points.forEach(([x,y],i) => {
      const svg = document.createElementNS(ns,'svg');
      svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('aria-hidden','true'); svg.setAttribute('focusable','false');
      svg.classList.add('steep-hero-twinkle');
      svg.style.cssText = `--spark-x:${x}%;--spark-y:${y}%;--spark-size:${10+i%4*3}px;--spark-duration:${1.2+i%4*.25}s;--spark-delay:${-i*.19}s`;
      const path = document.createElementNS(ns,'path');
      path.setAttribute('d','M12 0C13.5 8 16 10.5 24 12C16 13.5 13.5 16 12 24C10.5 16 8 13.5 0 12C8 10.5 10.5 8 12 0Z');
      svg.appendChild(path); layer.appendChild(svg);
    });
    parent.appendChild(layer);
  };
  const mount = async () => {
    await document.fonts.ready;
    const words = [...document.querySelectorAll(selector)];
    words[2]?.querySelectorAll('.steep-hero-twinkle,.steep-sparkle-layer').forEach(n => n.remove());
    if (words[0]) mountWord(words[0]);
    document.querySelectorAll('.steep-pdp-category .pdp-category__sparkling').forEach(mountWord);
    document.querySelectorAll('.ingredient-art.i0 .plant-composition > img').forEach(image => {
      mountLeaf(image);
      if (!image.dataset.steepLeafListener) {
        image.dataset.steepLeafListener = 'true';
        image.addEventListener('load',() => mountLeaf(image));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount,{once:true}); else mount();
  document.addEventListener('shopify:section:load',mount);
  let timer;
  window.addEventListener('resize',() => { clearTimeout(timer); timer=setTimeout(mount,150); });
})();
/* Mount only decorative children; retain purchase actions and accessible names. */
(() => {
 const ns='http://www.w3.org/2000/svg';
 const purchase='button[name="add"],button[ref="addToCartButton"],button[name="checkout"],[data-primary-buy],[data-floating-buy],.steep-pdp-v4 .cta,.stp7 .cta,a.button[href*="/products/"],a.button-custom[href*="/products/"],a.steep-home-floating__button[href*="/products/"]';
 const pack='.steep-pdp-v4 .pack-option,.stp7 .pack-option,.steep-menu-packs .steep-pack-card';
 const nutrition='.steep-pdp-v4 .nf,.stp7 .nf';
 const mount=(element,kind) => {
  element.classList.add('steep-hover-'+kind);
  if([...element.children].some(child=>child.classList.contains('steep-hover-decoration')))return;
  const layer=document.createElement('span');
  layer.className='steep-hover-decoration';
  layer.setAttribute('aria-hidden','true');
  const bolts=kind==='nutrition';
  const points=bolts?[[0,12],[100,23],[0,42],[100,55],[0,78],[100,87],[28,0],[76,100]]:[[8,22],[23,12],[41,28],[64,13],[85,23],[94,59],[77,83],[56,76],[30,86],[9,70],[48,9],[70,55]];
  points.forEach(([x,y],i)=>{
   const svg=document.createElementNS(ns,'svg');
   svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('focusable','false');
   svg.style.cssText=`--x:${x}%;--y:${y}%;--size:${bolts?23+i%3*4:10+i%4*3}px;--duration:${1.1+i%4*.23}s;--delay:${-i*.17}s`;
   const path=document.createElementNS(ns,'path');
   path.setAttribute('d',bolts?'M14 0L3 14H10L8 24L22 9H14L17 0Z':'M12 0C13.5 8 16 10.5 24 12C16 13.5 13.5 16 12 24C10.5 16 8 13.5 0 12C8 10.5 10.5 8 12 0Z');
   svg.appendChild(path);layer.appendChild(svg);
  });
  element.appendChild(layer);
 };

 const mountLightning=element=>{
  if(element.dataset.steepLightningMounted)return;
  element.dataset.steepLightningMounted='true';
  element.classList.add('steep-hover-nutrition');
  element.querySelectorAll(':scope > .steep-hover-decoration').forEach(n=>n.remove());
  const layer=document.createElement('span'),canvas=document.createElement('canvas');
  layer.className='steep-lightning-layer';layer.setAttribute('aria-hidden','true');
  layer.appendChild(canvas);element.appendChild(layer);
  const ctx=canvas.getContext('2d');
  if(!ctx)return;
  const motion=matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  let raf=0,start=0,last=0,hovering=false,touching=false;
  const stop=()=>{hovering=false;touching=false;cancelAnimationFrame(raf);raf=0;layer.classList.remove('is-active');element.style.removeProperty('--lightning-intensity');ctx.clearRect(0,0,canvas.width,canvas.height);};
  const draw=now=>{
   if(!element.isConnected||reduced.matches||(!motion.matches&&!touching)||!hovering){stop();return;}
   raf=requestAnimationFrame(draw);
   if(now-last<33)return;last=now;
   const intensity=Math.min(1,(now-start)/6000);
   element.style.setProperty('--lightning-intensity',intensity.toFixed(3));
   const w=element.offsetWidth,h=element.offsetHeight,pad=18,dpr=Math.min(devicePixelRatio||1,2);
   if(canvas.width!==Math.round((w+pad*2)*dpr)||canvas.height!==Math.round((h+pad*2)*dpr)){
    canvas.width=Math.round((w+pad*2)*dpr);canvas.height=Math.round((h+pad*2)*dpr);
   }
   ctx.setTransform(dpr,0,0,dpr,pad,pad);ctx.clearRect(-pad,-pad,w+pad*2,h+pad*2);
   const perimeter=2*(w+h),time=(now-start)/1000;
   const point=distance=>{
    let d=((distance%perimeter)+perimeter)%perimeter;
    if(d<w)return{x:d,y:0,nx:0,ny:-1};
    d-=w;if(d<h)return{x:w,y:d,nx:1,ny:0};
    d-=h;if(d<w)return{x:w-d,y:h,nx:0,ny:1};
    return{x:0,y:h-(d-w),nx:-1,ny:0};
   };
   const stroke=(points,width,alpha)=>{
    ctx.beginPath();points.forEach((p,i)=>i?ctx.lineTo(p.x,p.y):ctx.moveTo(p.x,p.y));
    ctx.strokeStyle='#c9a848';ctx.lineWidth=width+2;ctx.globalAlpha=alpha*.6;ctx.shadowColor='#c9a848';ctx.shadowBlur=7+intensity*7;ctx.stroke();
    ctx.strokeStyle='#fff9ee';ctx.lineWidth=width;ctx.globalAlpha=alpha;ctx.shadowBlur=3;ctx.stroke();
   };
   const count=2+Math.floor(intensity*3);
   for(let arc=0;arc<count;arc++){
    const distance=time*perimeter*(.11+intensity*.12)+arc*perimeter/count;
    const length=perimeter*(.14+intensity*.14),steps=Math.ceil(length/9),points=[];
    for(let i=0;i<=steps;i++){
     const p=point(distance+i*length/steps),envelope=Math.sin(Math.PI*i/steps);
     const jitter=(Math.sin(i*2.7+arc*3+time*18)*3+Math.sin(i*5.1-time*13)*2)*(1+intensity*.65)*envelope;
     points.push({x:p.x+p.nx*jitter,y:p.y+p.ny*jitter});
     if(i>0&&i<steps&&i%(intensity>.5?7:14)===0){
      const reach=5+intensity*9,branch=[points[i],{x:p.x+p.nx*reach*.55+p.ny*3,y:p.y+p.ny*reach*.55+p.nx*3},{x:p.x+p.nx*reach-p.ny*2,y:p.y+p.ny*reach-p.nx*2}];
      stroke(branch,.7+intensity*.4,.45+intensity*.35);
     }
    }
    stroke(points,1+intensity*.8,.75+intensity*.2);
   }
   ctx.globalAlpha=1;
  };
  element.addEventListener('pointerenter',()=>{if(!motion.matches||raf)return;hovering=true;start=performance.now();last=0;layer.classList.add('is-active');raf=requestAnimationFrame(draw);});
  element.addEventListener('steep:touch-effect',event=>{
   if(!event.detail.active){stop();return;}
   if(reduced.matches||raf)return;
   touching=true;hovering=true;start=performance.now();last=0;layer.classList.add('is-active');raf=requestAnimationFrame(draw);
  });
  element.addEventListener('pointerleave',()=>{if(!touching)stop();});
  element.addEventListener('pointercancel',stop);
  window.addEventListener('pagehide',stop);
  window.addEventListener('pageshow',stop);
  reduced.addEventListener('change',stop);
  motion.addEventListener('change',stop);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
 };
 const scan=()=>{document.querySelectorAll(purchase).forEach(e=>mount(e,'purchase'));document.querySelectorAll(pack).forEach(e=>mount(e,'pack'));document.querySelectorAll(nutrition).forEach(mountLightning);};
 let queued=false;
 const start=()=>{
  scan();
  new MutationObserver(records=>{
   if(!records.some(r=>[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1&&!n.classList.contains('steep-hover-decoration')&&!n.closest?.('.steep-hover-decoration'))))return;
   if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;scan();});}
  }).observe(document.body,{childList:true,subtree:true});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',scan);
})();

